module.exports = __webpack_public_path__ + "img/ico-instagram-circle.e710a000.svg";